const API_ENDPOINT_SERVER = process.env.REACT_APP_API_ENDPOINT_SERVER;
export const forgotPasswordAPI =
  API_ENDPOINT_SERVER + "account/forgot-password";
export const projectAPI1 = API_ENDPOINT_SERVER + "project/";
export const userAPI = API_ENDPOINT_SERVER + "auth/";
export const groupAPI = API_ENDPOINT_SERVER + "auth/groups";
export const datasetAPI = API_ENDPOINT_SERVER + "project/datasets/";
export const loginAPI = API_ENDPOINT_SERVER + "auth/login";
export const formAPI = API_ENDPOINT_SERVER + "project/dataset/";
